import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'banner',
  template: `
  <div id="content-wrapper">
    <div class="banner content">
        <h2>{{title}}</h2>
        <ng-content></ng-content>
    </div>
  </div>`,
  styles: [
    "#content-wrapper { width: 100%; float: left; } .banner { background-color: #FFCCCB; display: block; position: relative; border: solid thin #000000; border-radius: 5px; }"
  ]
})

export class BannerComponent {

  @Input("title") title: string = "Information";
}